<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions } from "vuex";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Fees Payment Breakdown",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, ModelListSelect },
  data() {
    return {
      id: atob(this.$route.params.id),
      pay: {
        id: atob(this.$route.params.id),
        amount: "",
        type: "",
        balance: 0,
        item: "",
      },
      deletedata: {
        id: atob(this.$route.params.id),
        item: "",
      },
      savedata: {
        id: atob(this.$route.params.id),
        balance: "",
      },
      amountError: "",
      itemError: "",
      tot: 0,
      item: [],
    };
  },
  computed: {
    ...mapGetters("fees", ["PaymentBreakdown"]),
  },

  methods: {
    ...mapActions({
      FetchReceipt: "fees/fetchPaymentBreakdown",
      AddBreak: "fees/addPaymentBreakdown",
      DeleteBreak: "fees/deletePaymentBreakdown",
      SaveBreak: "fees/savePaymentBreakdown",
    }),

    resetError() {
      this.amountError = "";
      this.itemError = "";
    },
    setItem() {
      this.item = this.PaymentBreakdown.breakdowns.filter((itemx) => {
        return itemx.id == this.pay.item;
      })[0];
      this.tot = this.item.bal;
      this.pay.type = this.item.type;
      this.pay.balance = this.item.bal;
      if (
        this.PaymentBreakdown.payment.amount1 - this.PaymentBreakdown.broken >=
        this.tot
      ) {
        this.pay.amount = this.tot;
      } else {
        this.pay.amount =
          this.PaymentBreakdown.payment.amount1 - this.PaymentBreakdown.broken;
      }
    },
    addBreakdown() {
      if (this.pay.amount > 0) {
        this.amountError = "";
      } else {
        this.amountError = "Please Enter Amount";
        return;
      }
      if (this.pay.item > 0) {
        this.itemError = "";
      } else {
        this.itemError = "Please Select an Item";
        return;
      }
      if (
        this.PaymentBreakdown.payment.amount1 - this.PaymentBreakdown.broken ==
        0
      ) {
        this.amountError = "Amount is depleted";
        return;
      }
      this.AddBreak(this.pay);
    },
    deleteBreakdown(id) {
      this.deletedata.item = id;
      this.DeleteBreak(this.deletedata);
    },
    saveBreakdown() {
      this.savedata.balance =
        this.PaymentBreakdown.payment.amount1 - this.PaymentBreakdown.broken;
      this.SaveBreak(this.savedata);
    },
  },
  updated() {
    // setTimeout(() => {
    //   window.print();
    // }, 1000);
  },
  created() {
    this.FetchReceipt(this.id);
  },
};
</script>

<style scoped>
.print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter,
    monospace;
}
</style>

<template>
  <Layout>
    <div class="row d-flex">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <!-- <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print Receipt</a
            > -->
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white">
          <div class="print-font p-3">
            <b-spinner
              v-if="!PaymentBreakdown"
              class="m-0"
              variant="primary"
              role="status"
            ></b-spinner>
            <div class="mt-3" v-else>
              <hr style="border-style: dashed; width: 100%" />
              <span>
                <strong>
                  FEES BREAKDOWN FOR
                  {{
                    PaymentBreakdown ? PaymentBreakdown.payment.student : ""
                  }}
                  OF
                  {{
                    PaymentBreakdown ? PaymentBreakdown.payment.amount : ""
                  }}
                  MADE ON
                  {{ PaymentBreakdown ? PaymentBreakdown.payment.pdate : "" }}
                  <br /> </strong
              ></span>
              <div class="row">
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Fee Item</label>
                        <div class="input-group">
                          <model-list-select
                            required
                            :list="
                              PaymentBreakdown
                                ? PaymentBreakdown.breakdowns
                                : []
                            "
                            v-model="pay.item"
                            option-value="id"
                            option-text="name"
                            class="mb-2"
                            @input="resetError(), setItem()"
                            placeholder="Select Item"
                          >
                          </model-list-select>
                        </div>
                        <div class="text-danger" v-if="itemError">
                          <em>{{ itemError }}</em>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label
                          >Amount (<small class="text-primary"
                            >Amount that was paid</small
                          >)</label
                        >
                        <div class="input-group">
                          <input
                            type="text"
                            placeholder="Enter Amount"
                            class="form-control"
                            @input="resetError()"
                            v-model="pay.amount"
                          />
                        </div>
                        <div class="text-danger" v-if="amountError">
                          <em>{{ amountError }}</em>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-2">
                      <br />
                      <button
                        class="btn btn-success"
                        @click="addBreakdown()"
                        v-if="
                          PaymentBreakdown.payment.amount1 -
                            PaymentBreakdown.broken >
                            0
                        "
                      >
                        <i class="fas fa-plus"></i> Add
                      </button>
                    </div>
                  </div>
                  <br />
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Item</th>
                        <th>Amount</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(dat, index) in PaymentBreakdown
                          ? PaymentBreakdown.paid
                          : []"
                        :key="index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>{{ dat.name }}</td>
                        <td>{{ dat.amount }}</td>
                        <td>
                          <button
                            class="btn btn-danger btn-sm"
                            @click="deleteBreakdown(dat.id)"
                          >
                            <i class="fas fa-trash"></i> Delete
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <center>
                    <button class="btn btn-primary" @click="saveBreakdown()">
                      <i class="fas fa-check"></i> Save Changes
                    </button>
                  </center> -->
                </div>
                <div class="col-md-4">
                  <h3>
                    TOTAL PAID:
                    <strong>{{
                      PaymentBreakdown ? PaymentBreakdown.payment.amount : ""
                    }}</strong>
                  </h3>
                  <h3>
                    BROKEN DOWN:
                    <strong>{{
                      PaymentBreakdown ? PaymentBreakdown.broken : ""
                    }}</strong>
                  </h3>
                  <h3>
                    BALANCE:
                    <strong>{{
                      PaymentBreakdown
                        ? PaymentBreakdown.payment.amount1 -
                          PaymentBreakdown.broken
                        : ""
                    }}</strong>
                  </h3>
                </div>
              </div>
              <!-- <table width="100%" class="mTable" style="font-size: 20px">
                  <tr width="100%">
                    <td width="20%">Name:</td>
                    <td width="30%">
                      <strong>{{ FeesReceipt ? FeesReceipt.name : "" }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td width="20%">Class:</td>
                    <td width="30%">
                      <strong>{{
                        FeesReceipt ? FeesReceipt.class : ""
                      }} Term {{FeesReceipt ? FeesReceipt.receipt.term : ""}}</strong>
                    </td>
                  </tr>
              </table> -->
              <br />
              <h4>Payment Details</h4>
              <hr style="border-style: dashed; width: 100%" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.dot {
  border-bottom: 1px dotted black;
}
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
